import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { COMUNICADOS_ADMIN_QK } from '@/hooks/use-comunicado-mutations';
import type { Comunicado, ComunicadoListItem } from '../types-comunicados';

const QK = COMUNICADOS_ADMIN_QK;

function toItem(rec: Comunicado): ComunicadoListItem {
  return {
    id: rec.id,
    title: rec.title || '(sin título)',
    is_published: rec.is_published,
    published_at: rec.published_at,
    created: rec.created,
    updated: rec.updated,
  };
}

export function useComunicadosList() {
  return useQuery({
    queryKey: QK,
    queryFn: async () => {
      const rows = await pb
        .collection('comunicados')
        .getFullList<Comunicado>({ sort: '-created' });
      return rows.map(toItem);
    },
  });
}

export function useComunicado(id: string | undefined) {
  return useQuery({
    queryKey: ['comunicado', id],
    queryFn: () =>
      pb.collection('comunicados').getOne<Comunicado>(id as string),
    enabled: !!id,
  });
}

export const COMUNICADOS_QK = QK;
